import { Page } from "../layout/Page";
import { CalendarMonth } from "../ui/CalendarMonth";
import { Section } from "../ui/Section";

/**
 * The old site's `/calendar`: a JS calendar widget with no heading of its
 * own and no intro copy, so "Calendar" is our heading, seeded to the real
 * current month. English only - the old page had no Hindi rendering.
 */
export function CalendarPage() {
  return (
    <Page title="Calendar" heading="Calendar">
      <Section>
        <CalendarMonth />
      </Section>
    </Page>
  );
}
